module.exports = __webpack_public_path__ + "1c959cc7f881293d92eba813b7dce1b1.png";